export const CAR_TYPE = { key: 'car', value: '汽車' };
export const MOTO_TYPE = { key: 'moto', value: '機車' };
export const TRAILER_TYPE = { key: 'trailer', value: '拖車' };
export const HEAVY_MOTO_TYPE = { key: 'heavy_moto', value: '大型重型機車' };

export const LICENSE_PLATE_TYPES = [CAR_TYPE, MOTO_TYPE, TRAILER_TYPE, HEAVY_MOTO_TYPE];
